const localUser = "user";

export const getUserDetails = () => {
    let userData = {}
    try{
        userData = JSON.parse(localStorage.getItem(localUser));
    }catch(e){
        console.log("Error:",userData);
    }
    finally{
        return userData;
    }
}

export const clearLocalStorage =()=>{
    localStorage.clear();
}